// extracted by mini-css-extract-plugin
export var alignCenter = "_ap-d";
export var bannerShown = "_ap-6";
export var buttonContent = "_ap-0";
export var cardList = "_ap-1";
export var centerContent = "_ap-2";
export var chevron = "_ap-3";
export var closePanelButton = "_ap-k";
export var conversationContextContainer = "_ap-l";
export var conversationDetailContainer = "_ap-4";
export var detailWrapper = "_ap-7";
export var dropdownButton = "_ap-e";
export var dropdownTitle = "_ap-9";
export var fullHeight = "_ap-5";
export var hidden = "_ap-a";
export var icon = "_ap-b";
export var mergeSuggestionWrapper = "_ap-m";
export var panel = "_ap-i";
export var portalButtonsWrapper = "_ap-c";
export var right = "_ap-j";
export var tableSummaryContainer = "_ap-8";
export var tableSummaryHeader = "_ap-g";
export var threeDotsButton = "_ap-f";
export var wide = "_ap-h";